module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "copyright-page",
      "id": "cip"
    }
  }, [_c('p', {
    staticClass: "crtf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "piv"
    }
  }), _vm._v("The University of Chicago Press, Chicago 60637")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("The University of Chicago Press, Ltd., London")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("© 2016 by Alice Kaplan")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("All rights reserved. Published 2016.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Paperback edition 2018")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("27 26 25 24 23 22 21 20 19 18    2 3 4 5 6")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("ISBN-13: 978-0-226-24167-8 (cloth)")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("ISBN-13: 978-0-226-56536-1 (paper)")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("ISBN-13: 978-0-226-24170-8 (e-book)")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("DOI: "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://doi.org/10.7208/chicago/9780226241708.001.0001",
      "target": "_blank"
    }
  }, [_vm._v("https://doi.org/10.7208/chicago/9780226241708.001.0001")])]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("Names: Kaplan, Alice Yaeger, author.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Title: Looking for The stranger : Albert Camus and the life of a literary classic / Alice Kaplan.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Description: Chicago ; London : The University of Chicago Press, 2016. | Includes bibliographical references and index.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Identifiers: LCCN 2016008498 | ISBN 9780226241678 (cloth : alk. paper) | ISBN 9780226241708 (e-book)")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Subjects: LCSH: Camus, Albert, 1913–1960. | Authors, French—Biography. | Philosophers—France—Biography. | Camus, Albert, 1913–1960. L’Étranger. | Camus, Albert, 1913–1960—Appreciation.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Classification: LCC PQ2605 .A3734 Z6694 2016 | DDC 848/ .91409—dc23")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("LC record available at "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://lccn.loc.gov/2016008498",
      "target": "_blank"
    }
  }, [_vm._v("http://lccn.loc.gov/2016008498")])]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "12",
      "src": "images/infinity-symbol.jpg",
      "width": "12"
    }
  }), _vm._v(" This paper meets the requirements of ANSI"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("/")]), _vm._v("NISO Z39.48-1992 (Permanence of Paper).")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49ddbd0f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-Kaplan-Stranger-US-pbk-0004.vue
// module id = 63
// module chunks = 0